import React from 'react';

import { Link, useHistory } from 'react-router-dom';
import { IonHeader, IonToolbar, IonButton, IonIcon, IonImg } from '@ionic/react';
import {
  search,
  person,
  cart,
  home,
  list,
  calendar,
  pricetags,
  documentText,
  chatbubbles,
  medkitOutline,
  eyedropOutline,
} from 'ionicons/icons';

import AuthResource from '../resources/Auth';

import './styles/desktop.js';

const DesktopHeader = ({ fpsConfigs, options, hasPromotionPosts, promotionsNumber }) => {
  const history = useHistory();
  const isLoggedIn = !!AuthResource.token;

  const navItems = [
    { label: 'Home', icon: home, path: '/app/home', show: true },
    {
      label: 'Prodotti',
      icon: list,
      path: '/app/category',
      show: fpsConfigs?.products > 0 && options?.buy_products_in_app === '1',
    },
    { label: 'Servizi', icon: calendar, path: '/app/services', show: fpsConfigs?.services > 0 },
    { label: 'Noleggio', icon: medkitOutline, path: '/app/rentals', show: fpsConfigs?.rentals > 0 },
    { label: 'Vaccini', icon: eyedropOutline, path: '/app/vaccini', show: fpsConfigs?.vaccines > 0 },
    {
      label: 'Carrello',
      icon: cart,
      path: '/app/cart',
      show: fpsConfigs?.products > 0 && options?.buy_products_in_app === '1',
    },
    { label: 'Prenotazioni', icon: calendar, path: '/app/reservations', show: fpsConfigs?.services > 0 },
    { label: 'Turni', icon: documentText, path: '/app/shift', show: !!options?.turni },
    { label: 'Promozioni', icon: pricetags, path: '/app/promotions', show: promotionsNumber > 0 || hasPromotionPosts || !!options?.volantino },
    {
      label: 'Ricette',
      icon: documentText,
      path: '/app/prescription-request',
      show: fpsConfigs?.prescription_request > 0 && options?.prescriptions !== '0',
    },
    { label: 'Chat', icon: chatbubbles, path: '/app/chat', show: options?.chat !== '0' },
  ];

  return (
    <IonHeader className="desktop-header">
      <IonToolbar>
        <div className="header-top">
          {/* Logo */}
          <Link to="/app/home" className="header-logo">
            <IonImg
              src={`${process.env.REACT_APP_API_URL}/logo/logo.png`}
              alt={process.env.APP_NAME || 'Logo'}
              style={{ height: '40px', maxWidth: '200px' }}
            />
          </Link>

          {/* Right side */}
          <div className="header-actions">
            {fpsConfigs?.products > 0 && options?.buy_products_in_app === '1' && (
              <IonButton fill="clear" className="action-button" onClick={() => history.push('/app/search')}>
                <IonIcon icon={search} />
              </IonButton>
            )}

            {/* <IonButton fill="clear" className="action-button">
              <IonIcon icon={notifications} />
              <IonBadge color="danger" className="badge-small">3</IonBadge>
            </IonButton> */}
            <IonButton fill="clear" className="action-button" routerLink={isLoggedIn ? '/app/user' : '/auth/login'}>
              <IonIcon icon={person} />
              <span>{isLoggedIn ? 'Account' : 'Accedi'}</span>
            </IonButton>
          </div>
        </div>
      </IonToolbar>

      <IonToolbar className="header-nav-toolbar">
        {/* Navigation */}
        <nav className="header-nav">
          {navItems
            .filter((item) => item.show)
            .map((item) => (
              <Link key={item.label} to={item.path} className="nav-link">
                <IonIcon icon={item.icon} className="nav-icon" />
                <span>{item.label}</span>
              </Link>
            ))}
        </nav>
      </IonToolbar>
    </IonHeader>
  );
};

export default DesktopHeader;
